import React, { useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import { KeyRound, Check } from "lucide-react";

export default function ChangePasswordCard() {
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [saving, setSaving] = useState(false);

    const reset = () => {
        setCurrent("");
        setNext("");
        setConfirm("");
    };

    const submit = async (e) => {
        e.preventDefault();
        if (next.length < 8) {
            toast.error("New password must be at least 8 characters");
            return;
        }
        if (next !== confirm) {
            toast.error("New password and confirmation do not match");
            return;
        }
        setSaving(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next });
            toast.success("Password updated");
            reset();
            setOpen(false);
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Update failed");
        } finally {
            setSaving(false);
        }
    };

    if (!open) {
        return (
            <button
                type="button"
                onClick={() => setOpen(true)}
                className="btn-secondary !py-2 !px-4"
                data-testid="open-change-password"
            >
                <KeyRound size={14} /> Change Password
            </button>
        );
    }

    return (
        <div className="tech-card !p-6 max-w-lg" data-testid="change-password-card">
            <div className="flex items-center gap-3 mb-5">
                <KeyRound size={16} className="text-[var(--accent-indigo)]" />
                <div className="font-serif-display text-xl">Change Password</div>
            </div>
            <form onSubmit={submit} className="space-y-4">
                <div>
                    <label className="tech-label mb-2 block">Current Password</label>
                    <input
                        required
                        type="password"
                        className="tech-input"
                        value={current}
                        onChange={(e) => setCurrent(e.target.value)}
                        data-testid="pw-current"
                    />
                </div>
                <div>
                    <label className="tech-label mb-2 block">New Password (min 8 chars)</label>
                    <input
                        required
                        type="password"
                        minLength={8}
                        className="tech-input"
                        value={next}
                        onChange={(e) => setNext(e.target.value)}
                        data-testid="pw-new"
                    />
                </div>
                <div>
                    <label className="tech-label mb-2 block">Confirm New Password</label>
                    <input
                        required
                        type="password"
                        minLength={8}
                        className="tech-input"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        data-testid="pw-confirm"
                    />
                </div>
                <div className="flex items-center gap-3 pt-2">
                    <button type="submit" className="btn-primary !py-2 !px-4" disabled={saving} data-testid="pw-submit">
                        <Check size={14} /> {saving ? "Updating…" : "Update Password"}
                    </button>
                    <button
                        type="button"
                        onClick={() => { reset(); setOpen(false); }}
                        className="btn-secondary !py-2 !px-4"
                        data-testid="pw-cancel"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
}
